import {
    CONTENT_LOAD_I18N_STRINGS,
    CONTENT_LOAD_VOCABULARY_FORMATS,
    CONTENT_LOAD_VOCABULARY_LANGUAGES
} from "./actions.type"
import {
    FormatService,
    LanguageService
} from "@/common/api.service";

const initialState = {
    contentLoaded: false,
    contentLanguages: null,
    contentFormats: null,
    i18n_strings: {}
}

export const state = { ...initialState };

export const actions = {
    async[CONTENT_LOAD_I18N_STRINGS](context) {
        context.commit("HydrateI18N", window.app_i18n_strings);
    },
    async[CONTENT_LOAD_VOCABULARY_FORMATS](context) {
        const { data } = await FormatService.list(document.documentElement.lang);
        context.commit("HydrateFormats", data);
        return data;
    },
    async[CONTENT_LOAD_VOCABULARY_LANGUAGES](context) {
        const { data } = await LanguageService.list(document.documentElement.lang);
        context.commit("HydrateLanguages", data);
        return data;
    }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
    HydrateI18N(state, i18n_strings) {
        state.i18n_strings = i18n_strings;
        state.contentLoaded = true;
    },
    HydrateFormats(state, s) {
        state.contentFormats = s.results;
    },
    HydrateLanguages(state, s) {
        state.contentLanguages = s.results;
    },
};

const getters = {
    i18n_strings(state) {
        return state.i18n_strings;
    },
    contentFormats(state) {
        return state.contentFormats;
    },
    contentLanguages(state) {
        return state.contentLanguages;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
